import React, { useState, useEffect } from 'react';
import VersionService from '../Services/VersionService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateRight, faArrowUp } from '@fortawesome/free-solid-svg-icons';

const UpdateBanner = () => {
  const [updateAvailable, setUpdateAvailable] = useState(VersionService.isUpdateAvailable());
  const [serverVersion, setServerVersion] = useState(VersionService.getServerVersion());
  const [isReloading, setIsReloading] = useState(false);

  useEffect(() => {
    return VersionService.onUpdateAvailable((info) => {
      setUpdateAvailable(true);
      setServerVersion(info.serverVersion);
    });
  }, []);

  if (!updateAvailable) return null;

  const handleForceReload = async () => {
    setIsReloading(true);
    await VersionService.forceReloadWithoutCache();
  };

  return (
    <div style={{
      backgroundColor: '#f59e0b',
      color: '#ffffff',
      padding: '8px 16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: '8px',
      fontSize: '14px',
      fontWeight: 500,
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      zIndex: 9999,
      position: 'relative'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <FontAwesomeIcon icon={faArrowUp} />
        <span>
          Υπάρχει νέα έκδοση διαθέσιμη {serverVersion ? `(v${serverVersion})` : ''}.
        </span>
      </div>
      <button
        type="button"
        onClick={handleForceReload}
        disabled={isReloading}
        style={{
          backgroundColor: '#ffffff',
          color: '#b45309',
          border: 'none',
          borderRadius: '4px',
          padding: '4px 12px',
          fontWeight: 600,
          cursor: isReloading ? 'not-allowed' : 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          fontSize: '13px',
          boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
        }}
      >
        <FontAwesomeIcon icon={faRotateRight} spin={isReloading} />
        <span>{isReloading ? 'Ανανέωση...' : 'Ανανέωση (χωρίς cache)'}</span>
      </button>
    </div>
  );
};

export default UpdateBanner;
